import React from 'react';
const ArrowDown = ({ color = '#BBBBBB', width = 8, height = 4 }) => {
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M8 9.53674e-07L4 4L3.49691e-07 2.54292e-07L8 9.53674e-07Z", fill: color })));
};
export default ArrowDown;
